<template lang="pug">
  vm-prompt(@vm-cancel="close" @vm-close="close" :vm-buttons-hidden="true" :vm-active="isModalViewInvoiceVisible" vm-title='Invoice')
    .modal-padding
      vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
        vm-col(vm-justify="center", vm-align="center", vm-w=6)
          b-form-group
            span {{ $t("payments.folio") }}: {{ invoice.folio }}
        vm-col(vm-justify="center", vm-align="center", vm-w=6)
          b-form-group
            span {{ $t("payments.invoice_date") }}: {{ invoice.invoice_date }}
        vm-col(vm-justify="center", vm-align="center", vm-w=6)
          b-form-group
            span {{ $t("payments.type") }}: {{ invoice.type_display }}
        vm-col(vm-justify="center", vm-align="center", vm-w=6)
          b-form-group
            span {{ $t("payments.created_by") }}: {{ invoice.created_by_display }}
      vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
        vm-col(vm-justify="center", vm-align="center", vm-w=12)
          .card-prices
            span {{$t('invoices.total')}}
            span.span-color  {{ invoice.amount | currency  }}
          .card-prices-green
            span {{$t('invoices.paidout')}}
            span.span-color-green  {{ invoice.balance | currency }}
          .card-prices
            span {{$t('invoices.remaining')}}
            span.span-color  {{ totalRestante | currency }}

</template>
<script>
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('InOrders')

export default {
  name: 'ModalViewInvoice',
  props: {
    invoice: {
      type: Object
    }
  },
  computed: {
    ...mapGetters([
      'isModalViewInvoiceVisible'
    ]),
    totalRestante () {
      let total = this.invoice.payments.reduce((prev, cur) => prev + parseFloat(cur.amount), 0).toFixed(2)
      return (this.invoice.amount - total).toFixed(2)
    }
  },
  methods: {
    ...mapActions([
      'setModalViewInvoiceVisible'
    ]),
    close () {
      this.setModalViewInvoiceVisible(false)
    }
  }
}
</script>
<style scoped>
.card-prices {
    font-size: 12px;
    border: 1px solid rgba(var(--primary),1);
    border-radius: 10px;
    margin: 7px 5px;
    padding: 3px 10px;
  }
  .card-prices-green {
    font-size: 12px;
    border: 1.5px solid green;
    border-radius: 10px;
    margin: 15px 5px;
    padding: 3px 10px;
  }
  .span-color {
    color:  rgba(var(--primary),1);
    font-weight: bold;
  }
  .span-color-green {
    color: green !important;
    font-weight: bold;
  }
  .modal-padding {
    padding: 20px 30px;
    font-size: 12px;
  }
</style>
